import { jsonldStartTime } from './JsonldStore';

export const updateJsonldStartTime = (value) => jsonldStartTime.update((oldValue) => value);
